export default __webpack_public_path__ + "static/media/logo-black.36d06d9a.svg";